export const SET_MERGE_REQUEST_STATUS = 'SET_MERGE_REQUEST_STATUS';
export const MERGE_SERVICE = 'lifesize.user.merge';
export const MERGE_REQUEST_URI = 'merge/request';
export const MERGE_REQUEST_ERROR_LIMIT_REACHED = 'LIMIT_REACHED';
export const MERGE_REQUEST_ERROR_EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND';
